document.addEventListener('DOMContentLoaded', () => {

  console.log('Bitrek website loaded');

  const isDesktop = window.matchMedia("(min-width: 1124px)");

  // Initialize mobile menu
  initMobileMenu()

  // Initialize solutions slider
  initSolutionsSwiper()

  // Initialize news slider
  initNewsSwiper()

  // Initialize Cases slider
  initCasesSwiper()

  // Initialize partners slider
  initPartnersSwiper()

  // Initialize taxonomy accordion
  initTaxAccordion()

  // Initialize filters switcher
  initFiltersSwitcher()

  // Initialize opportunities slider
  initOpportunitiesSwiper()

  // Initialize specs accordion
  initSpecsAccordion()

  // Initialize partners location filter
  initPartnersFilter()

  // Initialize FAQ accordion
  initFaqAccordion()

  anchorLinkActive()
  
  // Initialize partner form
  initPartnerForm()

  // Initialize consultation modal
  initConsultationModal()

  // Initialize contact form
  initContactForm()

  // Initialize solution accordion
  initSolutionAccordion()

  // Initialize PCB accordion (with image switching)
  initPcbAccordion()

  // Initialize quote form
  initQuoteForm()

  // Initialize vehicle tabs
  initVehicleTabs()

  // Initialize vehicle interactive markers
  initVehicleMarkers()

  // Initialize Hero Canvas
  initHeroCanvas(isDesktop)
})



// ==========================================================================
// Partners Location Filter
// ==========================================================================
function initPartnersFilter() {
  const filterBtns = document.querySelectorAll('.our-partners__filter-btn')
  const partnerCards = document.querySelectorAll('.our-partner-card')

  if (!filterBtns.length || !partnerCards.length) return

  filterBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const filterValue = btn.getAttribute('data-filter')

      // Update active state for buttons
      filterBtns.forEach(b => b.classList.remove('active'))
      btn.classList.add('active')

      // Filter cards
      partnerCards.forEach(card => {
        if (filterValue === 'all') {
          card.classList.remove('hidden')
        } else {
          const cardLocation = card.getAttribute('data-location')
          if (cardLocation === filterValue) {
            card.classList.remove('hidden')
          } else {
            card.classList.add('hidden')
          }
        }
      })
    })
  })
}


// ==========================================================================
// Mobile Menu
// ==========================================================================
function initMobileMenu() {
  const burgerBtn = document.getElementById('burgerBtn')
  const mobileMenu = document.getElementById('mobileMenu')

  if (!burgerBtn || !mobileMenu) return

  burgerBtn.addEventListener('click', () => {
    burgerBtn.classList.toggle('active')
    mobileMenu.classList.toggle('active')
    document.body.classList.toggle('menu-open')
  })

  // Close menu when clicking on links
  const mobileLinks = mobileMenu.querySelectorAll('a')
  mobileLinks.forEach(link => {
    link.addEventListener('click', () => {
      burgerBtn.classList.remove('active')
      mobileMenu.classList.remove('active')
      document.body.classList.remove('menu-open')
    })
  })

  // Submenu toggle logic
  const submenuArrows = mobileMenu.querySelectorAll('.header__mobile-submenu-arrow')
  submenuArrows.forEach(arrow => {
    arrow.addEventListener('click', (e) => {
      e.preventDefault()
      const parentItem = arrow.closest('.header__mobile-nav-item')
      if (parentItem) {
        parentItem.classList.toggle('open')
      }
    })
  })
}


// ==========================================================================
// Copy link to clipboard
// ==========================================================================
const copyLinkBtn = document.getElementById('copy-link-btn');

if (copyLinkBtn) {
  copyLinkBtn.addEventListener('click', function () {
    // Отримуємо поточну адресу сторінки
    const url = window.location.href;

    // Використовуємо Clipboard API
    navigator.clipboard.writeText(url).then(() => {
      // Візуальний фідбек для користувача
      btnText.style.opacity = '0.5';
      statusText.style.display = 'inline';

      // Повертаємо все як було через 2 секунди
      setTimeout(() => {
        btnText.style.opacity = '1';
        statusText.style.display = 'none';
      }, 2000);
    }).catch(err => {
      console.error('Copy error: ', err);
    });
  });
}


// ==========================================================================
// Solutions Swiper Slider
// ==========================================================================
function initSolutionsSwiper() {
  const swiperContainer = document.getElementById('solutionsSwiper')

  if (!swiperContainer) return

  new Swiper(swiperContainer, {
    slidesPerView: 1,
    spaceBetween: 80,
    loop: true,
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false,
    //   pauseOnMouseEnter: true
    // },
    pagination: {
      el: '.solutions__pagination',
      clickable: true,
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active'
    }
  })
}


// ==========================================================================
// Opportunities Swiper Slider (Product Page)
// ==========================================================================
function initOpportunitiesSwiper() {
  const swiperContainer = document.getElementById('opportunitiesSwiper')

  if (!swiperContainer) return

  new Swiper(swiperContainer, {
    slidesPerView: 1,
    spaceBetween: 80,
    loop: true,
    // autoplay: {
    //   delay: 5000,
    //   disableOnInteraction: false,
    //   pauseOnMouseEnter: true
    // },
    pagination: {
      el: '.product-opportunities__pagination',
      clickable: true,
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active'
    },
    navigation: {
      nextEl: ".product-opportunities__swiper-button-next",
      prevEl: ".product-opportunities__swiper-button-prev",
    },
  })
}


// ==========================================================================
// News Swiper Slider
// ==========================================================================
function initNewsSwiper() {
  const swiperContainer = document.getElementById('newsSwiper');
  const swiperContainerSolutions = document.getElementById('newsSwiper__solutions');

  if ( swiperContainer ) {

    new Swiper(swiperContainer, {
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: {
        el: '.news__pagination',
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active'
      },
      breakpoints: {
        420: {
          slidesPerView: 1.5,
        },
        768: {
          slidesPerView: 2.2,
        },
        1024: {
          slidesPerView: 3.3,
        },
        1440: {
          slidesPerView: 4
        }
      }
    })

  } else if ( swiperContainerSolutions ) {
    new Swiper(swiperContainerSolutions, {
      slidesPerView: 1,
      spaceBetween: 16,
      pagination: {
        el: '.news__pagination',
        clickable: true,
        bulletClass: 'swiper-pagination-bullet',
        bulletActiveClass: 'swiper-pagination-bullet-active'
      },
      breakpoints: {
        420: {
          slidesPerView: 1.5,
        },
        768: {
          slidesPerView: 2.2,
        },
        1024: {
          slidesPerView: 3,
        }
      }
    })
  }
}


// ==========================================================================
// Product cases Slider
// ==========================================================================
function initCasesSwiper() {
  const swiperContainer = document.getElementById('casesSwiper')

  if (!swiperContainer) return

  new Swiper(swiperContainer, {
    slidesPerView: 1,
    spaceBetween: 16,
    pagination: {
      el: '.product-cases__pagination',
      clickable: true,
      bulletClass: 'swiper-pagination-bullet',
      bulletActiveClass: 'swiper-pagination-bullet-active'
    },
    breakpoints: {
      420: {
        slidesPerView: 1.5,
      },
      768: {
        slidesPerView: 2.2,
      },
      1024: {
        slidesPerView: 3,
      }
    }
  })
}


// ==========================================================================
// Products Swiper Slider (Seamless)
// ==========================================================================
function initPartnersSwiper() {
  const swiperContainer = document.getElementById('partnersSwiper')

  if (!swiperContainer) return

  new Swiper(swiperContainer, {
    slidesPerView: 2,
    spaceBetween: 8,
    loop: true,
    speed: 5000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    allowTouchMove: false,
    breakpoints: {
      480: {
        slidesPerView: 3,
      },
      768: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 5,
      },
      1440: {
        slidesPerView: 6,
      },
    }
  })
}


// ==========================================================================
// Logistics slider
// ==========================================================================
document.querySelectorAll('.products__slider').forEach(item => {
  const isSmallDesktop = window.innerWidth < 1440;

  if (isSmallDesktop) {

    new Swiper(item, {
      slidesPerView: 1,
      spaceBetween: 8,
      loop: true,
      speed: 5000,
      autoplay: {
        delay: 0,
        disableOnInteraction: false,
      },
      allowTouchMove: false,
      breakpoints: {
        480: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 4,
        },
        1024: {
          slidesPerView: 5,
        },
        1440: {
          slidesPerView: 6,
        },
      }
    });
  }
});


// ==========================================================================
// Integration Hero Slider
// ==========================================================================
document.querySelectorAll('.integration-hero__slider-block').forEach(section => {
  const thumbsEl = section.querySelector('.integration-hero__swiper-second');
  const mainEl = section.querySelector('.integration-hero__swiper-main');

  const thumbsSwiper = new Swiper(thumbsEl, {
    slidesPerView: 3,
    spaceBetween: 8,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    freeMode: true,
    watchSlidesVisibility: true,

    breakpoints: {
      480: {
        slidesPerView: 4,
      },
    }
  });

  new Swiper(mainEl, {
    loop: true,
    effect: "fade",
    navigation: {
      nextEl: section.querySelector('.integration-hero__button-next'),
      prevEl: section.querySelector('.integration-hero__button-prev'),
    },

    thumbs: {
      swiper: thumbsSwiper,
    },
  });
});


// ==========================================================================
// Product categories Slider
// ==========================================================================
document.querySelectorAll('.categories__swiper').forEach(section => {

  if (!section) return

  new Swiper(section, {
    slidesPerView: 1.05,
    spaceBetween: 16,
    breakpoints: {
      420: {
        slidesPerView: 1.15,
      },
      768: {
        slidesPerView: 2.2,
      },
      1024: {
        slidesPerView: 2.6,
      },
      1439: {
        slidesPerView: 3.03,
      },
    }
  })
});


// ==========================================================================
// Product Hero Slider
// ==========================================================================
document.querySelectorAll('.product-hero__slider-block').forEach(section => {
  const thumbsEl = section.querySelector('.product-hero__swiper-second');
  const mainEl = section.querySelector('.product-hero__swiper-main');

  const thumbsSwiper = new Swiper(thumbsEl, {
    slidesPerView: 3,
    spaceBetween: 8,
    watchSlidesProgress: true,
    slideToClickedSlide: true,
    freeMode: true,
    watchSlidesVisibility: true,

    breakpoints: {
      480: {
        slidesPerView: 4,
      },
    }
  });

  new Swiper(mainEl, {
    loop: true,
    effect: "fade",
    navigation: {
      nextEl: section.querySelector('.product-hero__button-next'),
      prevEl: section.querySelector('.product-hero__button-prev'),
    },

    thumbs: {
      swiper: thumbsSwiper,
    },
  });
});




// ==========================================================================
// Products Taxonomy accordion
// ==========================================================================
function initTaxAccordion() {
  const taxItems = document.querySelectorAll('.product-categories');

  if (!taxItems.length) return;

  // Close accordion item
  function closeItem(item) {
    const list = item.querySelector('.product-categories__taxonomy-list');
    list.style.maxHeight = null;
    item.classList.remove('product-categories--active');
  }

  // Open accordion item
  function openItem(item) {
    const list = item.querySelector('.product-categories__taxonomy-list');
    list.style.maxHeight = list.scrollHeight + 'px';
    item.classList.add('product-categories--active');
  }

  taxItems.forEach(item => {
    const title = item.querySelector('.product-categories__taxonomy-title');

    title.addEventListener('click', () => {
      const isActive = item.classList.contains('product-categories--active');
      // Close all items
      // taxItems.forEach(i => closeItem(i));

      // Open/Close clicked item if it wasn't active
      if (isActive) {
        closeItem(item);
        title.classList.remove('product-categories__taxonomy-title--active');
      } else {
        openItem(item);
        title.classList.add('product-categories__taxonomy-title--active');
      }
    });
  });
}


// ==========================================================================
// Filters Switcher
// ==========================================================================
function initFiltersSwitcher() {
  const switcher = document.getElementById('filters_switcher');
  const inner = document.querySelector('.all-products__inner');

  if (!switcher || !inner) return;

  switcher.addEventListener('click', () => {
    switcher.classList.toggle('all-products__switcher--hidden-filters');
    inner.classList.toggle('all-products__inner--hidden-filters');
  });
}


// ==========================================================================
// Specs Accordion
// ==========================================================================
function initSpecsAccordion() {
  const items = document.querySelectorAll('.specs__item')

  if (!items.length) return

  items.forEach((item) => {
    const header = item.querySelector('.specs__header')
    if (!header) return

    header.addEventListener('click', () => {
      const isOpen = item.classList.contains('specs__item--open')

      // Close all
      items.forEach((other) => {
        other.classList.remove('specs__item--open')
        const otherHeader = other.querySelector('.specs__header')
        if (otherHeader) otherHeader.setAttribute('aria-expanded', 'false')
      })

      // Open clicked if it was closed
      if (!isOpen) {
        item.classList.add('specs__item--open')
        header.setAttribute('aria-expanded', 'true')
      }
    })
  })
}


// ==========================================================================
// FAQ Accordion
// ==========================================================================
function initFaqAccordion() {
  const items = document.querySelectorAll('.faq__item')

  if (!items.length) return

  items.forEach((item) => {
    // const header = item.querySelector('.specs__header')
    // if (!header) return

    item.addEventListener('click', () => {
      const isOpen = item.classList.contains('faq__item--open')

      // Close all
      items.forEach((other) => {
        other.classList.remove('faq__item--open')
      })

      // Open clicked if it was closed
      if (!isOpen) {
        item.classList.add('faq__item--open')
      }
    })
  })
}


// Contact Form (single step with validation)
function initContactForm() {
  const form = document.getElementById('contactForm')
  if (!form) return

  const success = document.getElementById('cfSuccess')

  function validateField(field) {
    const errorEl = field.parentElement.querySelector('.contacts__error')
    let valid = true

    if (field.type === 'checkbox') {
      valid = field.checked
    } else {
      const value = field.value.trim()
      if (!value) {
        valid = false
      } else if (field.dataset.type === 'email') {
        valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
      } else if (field.dataset.type === 'phone') {
        valid = /^[+]?[\d\s()-]{7,}$/.test(value)
      }
    }

    if (valid) {
      field.classList.remove('is-invalid')
      const cb = field.closest('.contacts__checkbox')
      if (cb) cb.classList.remove('is-invalid')
      if (errorEl) errorEl.classList.remove('is-visible')
    } else {
      field.classList.add('is-invalid')
      const cb = field.closest('.contacts__checkbox')
      if (cb) cb.classList.add('is-invalid')
      if (errorEl) errorEl.classList.add('is-visible')
    }

    return valid
  }

  // Color the select when an option is chosen
  form.querySelectorAll('.contacts__select').forEach((select) => {
    select.addEventListener('change', () => {
      select.classList.toggle('contacts__select--filled', !!select.value)
    })
  })

  // Live validation
  form.querySelectorAll('[data-required]').forEach((field) => {
    const evt = field.type === 'checkbox' ? 'change' : 'input'
    field.addEventListener(evt, () => validateField(field))
  })

  form.addEventListener('submit', (e) => {
    e.preventDefault()
    let allValid = true
    form.querySelectorAll('[data-required]').forEach((field) => {
      if (!validateField(field)) allValid = false
    })

    if (allValid) {
      if (typeof window.handleFormSubmission === 'function') {
        window.handleFormSubmission(form, success)
      }
    }
  })
}

function initConsultationModal() {
  const consultationModal = document.querySelector('.consultation-modal')
  const consultationOpenBtns = document.querySelectorAll('[data-consultation-modal]')
  const consultationCloseBtn = document.getElementById('consultationClose')
  const consultationOverlay = document.getElementById('consultationCloseOverlay')
  const form = document.getElementById('consultationForm')
  const success = document.getElementById('consSuccess')

  if (consultationModal && consultationOpenBtns.length > 0) {
    consultationOpenBtns.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault()
        requestAnimationFrame(() => {
          consultationModal.classList.add('active')
          document.body.classList.add('overflow-hidden')
        })
      })
    })

    const closeConsModal = () => {
      consultationModal.classList.remove('active')
      document.body.classList.remove('overflow-hidden')
    }

    if (consultationCloseBtn) consultationCloseBtn.addEventListener('click', closeConsModal)
    if (consultationOverlay) consultationOverlay.addEventListener('click', closeConsModal)

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && consultationModal.classList.contains('active')) {
        closeConsModal()
      }
    })

    if (form) {
      function validateField(field) {
        const errorEl = field.parentElement.querySelector('.consultation-modal__error')
        let valid = true

        if (field.type === 'checkbox') {
          valid = field.checked
        } else {
          const value = field.value.trim()
          if (!value) {
            valid = false
          } else if (field.dataset.type === 'email') {
            valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
          } else if (field.dataset.type === 'phone') {
            valid = /^[+]?[\d\s()-]{7,}$/.test(value)
          }
        }

        if (valid) {
          field.classList.remove('is-invalid')
          if (errorEl) errorEl.classList.remove('is-visible')
        } else {
          field.classList.add('is-invalid')
          if (errorEl) errorEl.classList.add('is-visible')
        }

        return valid
      }

      form.querySelectorAll('[data-required]').forEach((field) => {
        const evt = field.type === 'checkbox' ? 'change' : 'input'
        field.addEventListener(evt, () => validateField(field))
      })

      form.addEventListener('submit', (e) => {
        e.preventDefault()
        let allValid = true
        form.querySelectorAll('[data-required]').forEach((field) => {
          if (!validateField(field)) allValid = false
        })

        if (allValid) {
          if (typeof window.handleFormSubmission === 'function') {
            window.handleFormSubmission(form, success)
          }
        }
      })
    }
  }
}


// Partner Form (2-step with validation)
function initPartnerForm() {
  const form = document.getElementById('partnerForm')
  if (!form) return

  const modal = form.closest('.partner-form')
  const openBtns = document.querySelectorAll('[data-partner-modal]')
  const closeBtn = document.getElementById('partnerFormClose')

  if (openBtns.length > 0 && modal) {
    openBtns.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault()
        requestAnimationFrame(() => {
          modal.classList.add('active')
          document.body.classList.add('overflow-hidden')
        })
      })
    })
  }

  if (closeBtn && modal) {
    closeBtn.addEventListener('click', () => {
      modal.classList.remove('active')
      document.body.classList.remove('overflow-hidden')
    })
  }


  const steps = form.querySelectorAll('.partner-form__step')
  const nextBtn = document.getElementById('nextStep')
  const prevBtn = document.getElementById('prevStep')
  const stepNum = document.getElementById('stepNum')
  const stepName = document.getElementById('stepName')
  const progress2 = document.getElementById('progress2')
  const success = document.getElementById('pfSuccess')

  const stepNames = {
    1: 'Ваша контактна інформація',
    2: 'Мета придбання Bitrek',
  }

  // Validate a single field
  function validateField(field) {
    const errorEl = field.parentElement.querySelector('.partner-form__error')
    let valid = true

    if (field.type === 'checkbox') {
      valid = field.checked
    } else {
      const value = field.value.trim()
      if (!value) {
        valid = false
      } else if (field.dataset.type === 'email') {
        valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
      } else if (field.dataset.type === 'phone') {
        valid = /^[+]?[\d\s()-]{7,}$/.test(value)
      }
    }

    if (valid) {
      field.classList.remove('is-invalid')
      if (field.closest('.partner-form__checkbox')) {
        field.closest('.partner-form__checkbox').classList.remove('is-invalid')
      }
      if (errorEl) errorEl.classList.remove('is-visible')
    } else {
      field.classList.add('is-invalid')
      if (field.closest('.partner-form__checkbox')) {
        field.closest('.partner-form__checkbox').classList.add('is-invalid')
      }
      if (errorEl) errorEl.classList.add('is-visible')
    }

    return valid
  }

  // Validate all required fields in a step
  function validateStep(stepEl) {
    const requiredFields = stepEl.querySelectorAll('[data-required]')
    let allValid = true

    requiredFields.forEach((field) => {
      if (!validateField(field)) {
        allValid = false
      }
    })

    return allValid
  }

  function goToStep(n) {
    steps.forEach((s) => {
      s.classList.toggle('partner-form__step--active', Number(s.dataset.step) === n)
    })
    stepNum.textContent = `Крок ${n}/2.`
    stepName.textContent = stepNames[n]
    progress2.classList.toggle('partner-form__progress-bar--filled', n >= 2)
  }

  // Clear validation styling on input
  form.querySelectorAll('[data-required]').forEach((field) => {
    const evt = field.type === 'checkbox' ? 'change' : 'input'
    field.addEventListener(evt, () => validateField(field))
  })

  nextBtn.addEventListener('click', () => {
    const step1 = form.querySelector('[data-step="1"]')
    if (validateStep(step1)) {
      goToStep(2)
    }
  })

  prevBtn.addEventListener('click', () => {
    goToStep(1)
  })

  form.addEventListener('submit', (e) => {
    e.preventDefault()
    const step2 = form.querySelector('[data-step="2"]')
    if (validateStep(step2)) {
      if (typeof window.handleFormSubmission === 'function') {
        window.handleFormSubmission(form, success)
      } else {
        console.error('handleFormSubmission is not defined')
      }
    }
  })
}


function anchorLinkActive() {
  const anchors = document.querySelectorAll('.product-headers__anchor-link')

  if (!anchors.length) return

  anchors.forEach((anchor) => {

    anchor.addEventListener('click', () => {

      anchors.forEach((other) => {
        other.classList.remove('product-headers__anchor-link--active')
      })

      anchor.classList.add('product-headers__anchor-link--active');
    })
  })
}


// begin::Smooth scroll for anchor links
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    const href = this.getAttribute('href');

    // Ігноруємо порожні якорі
    if (href.length <= 1) return;

    // Вирізаємо '#' і шукаємо по чистому ID (щоб не ламалося на '&')
    const targetId = href.substring(1);
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      e.preventDefault();

      // 1. Отримуємо відстань від верху документа до елемента
      const elementPosition = targetElement.getBoundingClientRect().top;

      // 2. Отримуємо поточну позицію скролу
      const offsetPosition = elementPosition + window.scrollY - 100;

      // 3. Запускаємо плавний скрол у розраховану точку
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  });
});



// Solution Accordion
function initSolutionAccordion() {
  const items = document.querySelectorAll('.solution__item')

  if (!items.length) return

  items.forEach((item) => {
    const header = item.querySelector('.solution__header-btn')
    if (!header) return

    header.addEventListener('click', () => {
      const isOpen = item.classList.contains('solution__item--open')

      // Close all
      items.forEach((other) => {
        other.classList.remove('solution__item--open')
        const otherHeader = other.querySelector('.solution__header-btn')
        if (otherHeader) otherHeader.setAttribute('aria-expanded', 'false')
      })

      // Open clicked if it was closed
      if (!isOpen) {
        item.classList.add('solution__item--open')
        header.setAttribute('aria-expanded', 'true')
      }
    })
  })
}


// PCB Accordion (with synced media switching - one accordion = one media)
function initPcbAccordion() {
  const section = document.querySelector('.pcb')
  if (!section) return

  const items = section.querySelectorAll('.pcb__item')
  const mainMedia = section.querySelectorAll('[data-pcb-main]')
  const miniImages = section.querySelectorAll('[data-pcb-mini]')

  const mainMediaContainer = section.querySelector('.pcb__media-main')

  if (!items.length) return

  function handleMedia(step) {
    if (mainMediaContainer) {
      mainMediaContainer.dataset.activeStep = step
    }
    mainMedia.forEach((el) => {
      const isActive = el.dataset.pcbMain === step
      el.classList.toggle('pcb__img--active', isActive)

      // Video control
      if (el.tagName.toLowerCase() === 'video') {
        if (isActive) {
          el.play().catch(() => {
            // handle autoplay restriction if needed
          })
        } else {
          el.pause()
          el.currentTime = 0
        }
      }
    })

    miniImages.forEach((img) => {
      img.classList.toggle('pcb__img--active', img.dataset.pcbMini === step)
    })
  }

  // Initial media state for open items (autoplay for first video if it is active)
  const initialOpenItem = section.querySelector('.pcb__item--open')
  if (initialOpenItem) {
    handleMedia(initialOpenItem.dataset.pcbStep)
  }

  items.forEach((item) => {
    const header = item.querySelector('.pcb__header-btn')
    if (!header) return

    header.addEventListener('click', () => {
      const isOpen = item.classList.contains('pcb__item--open')

      // Always keep one open: clicking an open item does nothing
      if (isOpen) return

      // Close all
      items.forEach((other) => {
        other.classList.remove('pcb__item--open')
        const otherHeader = other.querySelector('.pcb__header-btn')
        if (otherHeader) otherHeader.setAttribute('aria-expanded', 'false')
      })

      // Open clicked
      item.classList.add('pcb__item--open')
      header.setAttribute('aria-expanded', 'true')

      // Sync media
      handleMedia(item.dataset.pcbStep)
    })
  })
}


// Quote Form (single step with validation)
function initQuoteForm() {
  const form = document.getElementById('quoteForm')
  if (!form) return

  const success = document.getElementById('quoteSuccess')

  function validateField(field) {
    const errorEl = field.parentElement.querySelector('.quote__error')
    let valid = true

    if (field.type === 'checkbox') {
      valid = field.checked
    } else {
      const value = field.value.trim()
      if (!value) {
        valid = false
      } else if (field.dataset.type === 'email') {
        valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)
      } else if (field.dataset.type === 'phone') {
        valid = /^[+]?[\d\s()-]{7,}$/.test(value)
      }
    }

    if (valid) {
      field.classList.remove('is-invalid')
      if (field.closest('.quote__checkbox')) {
        field.closest('.quote__checkbox').classList.remove('is-invalid')
      }
      if (errorEl) errorEl.classList.remove('is-visible')
    } else {
      field.classList.add('is-invalid')
      if (field.closest('.quote__checkbox')) {
        field.closest('.quote__checkbox').classList.add('is-invalid')
      }
      if (errorEl) errorEl.classList.add('is-visible')
    }

    return valid
  }

  // Clear validation styling on input
  form.querySelectorAll('[data-required]').forEach((field) => {
    const evt = field.type === 'checkbox' ? 'change' : 'input'
    field.addEventListener(evt, () => validateField(field))
  })

  form.addEventListener('submit', (e) => {
    e.preventDefault()
    let allValid = true
    form.querySelectorAll('[data-required]').forEach((field) => {
      if (!validateField(field)) allValid = false
    })

    if (allValid) {
      if (typeof window.handleFormSubmission === 'function') {
        window.handleFormSubmission(form, success)
      }
    }
  })
}


// ==========================================================================
// Vehicle Tabs
// ==========================================================================
function initVehicleTabs() {
  const tabs = document.querySelectorAll('[data-vehicle-tab]')
  const contents = document.querySelectorAll('[data-vehicle-content]')

  if (!tabs.length || !contents.length) return

  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const targetType = tab.getAttribute('data-vehicle-tab')

      // Update active state for buttons
      tabs.forEach(t => t.classList.remove('active'))
      tab.classList.add('active')

      // Switch content
      contents.forEach(content => {
        if (content.getAttribute('data-vehicle-content') === targetType) {
          content.classList.add('active')
        } else {
          content.classList.remove('active')
        }
      })
    })
  })
}


// Vehicle Interactive Markers (tap-to-toggle on touch, hover on desktop)
function initVehicleMarkers() {
  const stages = document.querySelectorAll('[data-vehicle-stage]')
  if (!stages.length) return

  stages.forEach((stage) => {
    const spots = Array.from(stage.querySelectorAll('.vehicle__spot'))
    const vehicleItem = stage.closest('.vehicle__item')
    const panel = vehicleItem ? vehicleItem.querySelector('[data-vehicle-panel]') : null
    const panelContent = panel ? panel.querySelector('.vehicle__panel-content') : null

    function closeAll(except) {
      spots.forEach((spot) => {
        if (spot !== except) spot.classList.remove('is-active')
      })
    }

    // Softly swap the stable mobile panel content with the selected marker's info
    function updatePanel(spot) {
      if (!panel || !panelContent) return
      const tooltip = spot.querySelector('.vehicle__tooltip')
      if (!tooltip) return
      const isDanger = spot.classList.contains('vehicle__spot--danger')

      panel.classList.add('is-swapping')
      window.setTimeout(() => {
        panelContent.innerHTML = tooltip.innerHTML
        panelContent.classList.toggle('vehicle__panel-content--danger', isDanger)
        panel.classList.remove('is-swapping')
      }, 200)
    }

    spots.forEach((spot) => {
      const marker = spot.querySelector('.vehicle__marker')
      if (!marker) return

      marker.addEventListener('click', (e) => {
        e.stopPropagation()
        const willOpen = !spot.classList.contains('is-active')
        closeAll(spot)
        spot.classList.toggle('is-active', willOpen)
        if (willOpen) updatePanel(spot)
      })
    })

    // Close any open tooltip when tapping/clicking elsewhere
    document.addEventListener('click', () => closeAll(null))

    // Close on Escape
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll(null)
    })
  })
}


// ==========================================================================
// Hero Canvas Animation
// ==========================================================================
function initHeroCanvas(e) {

  if (e.matches) {

    const stage = document.querySelector('#stage');
    if (!stage) return;

    const section = stage.closest('.solutions-hero');
    if (!section) return;

    const ctx = stage.getContext('2d');
    const ratio = window.devicePixelRatio || 1;
    const mouse = {x: 0, y: 0};
    let dots = [];
    const wide = 36;
    const high = 16; // Fixed rows for better control
    const padding = 50;

    let cb = stage.getBoundingClientRect();

    function updateSize() {
      const width = section.offsetWidth;
      const height = section.offsetHeight;
      stage.width = width * ratio;
      stage.height = height * ratio;
      stage.style.width = width + 'px';
      stage.style.height = height + 'px';
      cb = stage.getBoundingClientRect();
      createDots();
    }

    function createDots() {
      dots = [];
      for (let i = 0; i < wide; i++) {
        const x = Math.floor((((cb.width - padding * 2) / (wide - 1)) * i) + padding) * ratio;
        for (let j = 0; j < high; j++) {
          const y = Math.floor((((cb.height - padding * 2) / (high - 1)) * j) + padding) * ratio;
          dots.push({
            x: x,
            y: y,
            ox: x,
            oy: y,
            size: 1
          });
        }
      }
    }

    function getDistance(obj1, obj2) {
      const dx = obj1.x - obj2.x;
      const dy = obj1.y - obj2.y;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function getAngle(obj1, obj2) {
      const dX = obj2.x - obj1.x;
      const dY = obj2.y - obj1.y;
      return Math.atan2(dY, dX) / Math.PI * 180;
    }

    function getV(dot) {
      const d = getDistance(dot, mouse);
      dot.size = (200 * ratio - d) / (20 * ratio);
      dot.size = dot.size < 1 ? 1 : dot.size;
      const angle = getAngle(dot, mouse);
      const moveDist = d > 20 * ratio ? 20 * ratio : d;

      return {
        x: moveDist * Math.cos(angle * Math.PI / 180),
        y: moveDist * Math.sin(angle * Math.PI / 180)
      };
    }

    function render() {
      ctx.clearRect(0, 0, stage.width, stage.height);
      ctx.fillStyle = '#fff';

      dots.forEach(s => {
        const v = getV(s);
        ctx.beginPath();
        ctx.moveTo(s.x, s.y);
        ctx.lineTo(s.x + v.x, s.y + v.y);
        ctx.strokeStyle = '#333';
        ctx.lineWidth = 1 * ratio;
        ctx.stroke();
        ctx.closePath();
      });

      dots.forEach(s => {
        const v = getV(s);
        ctx.beginPath();
        ctx.arc(s.x + v.x, s.y + v.y, s.size * ratio, 0, 2 * Math.PI, false);
        ctx.fill();
        ctx.closePath();
      });

      requestAnimationFrame(render);
    }

    window.addEventListener('mousemove', (e) => {
      mouse.x = (e.clientX - cb.left) * ratio;
      mouse.y = (e.clientY - cb.top) * ratio;
    });

    window.addEventListener('resize', updateSize);

    updateSize();
    render();

  }
}